import React from 'react'
import { usePaginationFragment, graphql } from 'react-relay'

import { YStack, XStack, Separator } from 'tamagui'
import { Strong } from '@newComponents/Text'
import { Button } from '@newComponents/Button/Button'
import { PresentationItem } from '@newComponents/Presentation/PresentationItem'

import { UserPresentationsScreenUpcomingPresentationsSection_user$key } from './__generated__/UserPresentationsScreenUpcomingPresentationsSection_user.graphql'

export const UserPresentationsScreenUpcomingPresentationsSection = ({
  user,
}: {
  user: UserPresentationsScreenUpcomingPresentationsSection_user$key
}) => {
  const { data, hasNext, loadNext, isLoadingNext } = usePaginationFragment(
    graphql`
      fragment UserPresentationsScreenUpcomingPresentationsSection_user on User
      @refetchable(
        queryName: "UserPresentationsScreenUpcomingPresentationsSectionPaginationQuery"
      )
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 3 }
        cursor: { type: "Cursor" }
      ) {
        upcomingPresentations: presentations(
          first: $count
          after: $cursor
          timeSelection: UPCOMING
          orderBy: [CREATED_AT_DESC, ID_ASC]
        )
          @connection(
            key: "UserPresentationsScreenUpcomingPresentationsSection_user_upcomingPresentations"
          ) {
          edges {
            node {
              ...PresentationItemNew_presentation
            }

            cursor
          }
        }
      }
    `,
    user
  )

  if (data.upcomingPresentations.edges.length === 0) {
    return null
  }

  return (
    <YStack gap='$4'>
      <XStack gap='$4' alignItems='center'>
        <Strong color='$grey8'>Upcoming Presentations</Strong>
        <Separator borderColor='$grey4' />
      </XStack>

      {data.upcomingPresentations.edges.map((edge) => {
        return (
          <PresentationItem
            key={edge.cursor}
            presentation={edge.node}
            numberOfLines={8}
          />
        )
      })}

      {hasNext && (
        <Button
          secondary
          onPress={() => {
            if (isLoadingNext) {
              return
            }

            loadNext(3)
          }}
        >
          <Button.Text secondary>
            {isLoadingNext ? 'Loading...' : 'More'}
          </Button.Text>
        </Button>
      )}
    </YStack>
  )
}
